export class HealthCheck {
  public readonly data: {
    crewMemberId: string;
    docType: string;
    lastUpdateSource: string;
    lastUpdated: string;
    shipCode: string;
    signonDate: string;
    hasSymptom: boolean;
  };

  constructor(
    data: any,
    public readonly symptoms: Array<{ key: string; value: string }>,
    public readonly questions: Array<{ key: string; value: string }>,
  ) {
    this.data = data;
  }

  public get hasSymptom(): boolean {
    return this.data.hasSymptom;
  }
}
